import React, { useContext, useState, useEffect, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { AuthContext } from "context/AuthContext";
import {
  SvgAlertPeopleCoat,
  SvgAlertPeopleTrousers,
  SvgAlertVehicleColor,
  SvgAlertReviewed,
  SvgLogo,
  SvgBlackShield,
  SvgToastInfo,
} from "ui/svgs";
import clsx from "clsx";
import {
  formatContextDate,
  formatMinute,
  formatAlertStatusSDKToDisplay,
  getAlertStatusStyles,
  getEventText,
  copyToClipBoard,
} from "lib/utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Popover, Tooltip } from "antd";
import { ALERT_VEHICLE_CAR_COLOR, USER_ROLE } from "lib/constants";
import { useService } from "pages/dashboard/alerts/service";
import { AlertDataType } from "lib/types";
import { REGION_INDEX_COLOR } from "lib/constants";
import { CopyOutlined } from "@ant-design/icons";
export default function AlertsItem({
  alertId,
  dataAlert,
  setVideoUrl,
  activeAlert,
  setActiveAlert,
}: {
  alertId: string;
  dataAlert: AlertDataType;
  setVideoUrl: (url: string) => void;
  activeAlert: AlertDataType;
  setActiveAlert: (alert: AlertDataType) => void;
}) {
  const { user } = useContext(AuthContext);
  //const navigate = useNavigate();
  // const { setVideoUrl } = useContext(AlertsContext);
  //  const { activeAlert, setActiveAlert } = useContext(AlertsControlBarContext);
  const imgRef = useRef<HTMLImageElement>(null);
  const [thisAlertStatus, setThisAlertStatus] = useState(null);
  const [thisAlertTag, setThisAlertTag] = useState(null);
  const [thisTagDesc, setThisTagTagDesc] = useState(null);
  const [thisReviewed, setThisReviewed] = useState(false);
  const [naturalSize, setNaturalSize] = useState({ width: 0, height: 0 });
  const { getSnapShotByAlertObj, getTargetImgByAlertObj } = useService();
  const [snapShotSrc, setSnapShotSrc] = useState(null);
  const [targetImgSrc, setTargetImgSrc] = useState("");
  const [snapShotWithBoxSrc, setSnapShotWithBoxSrc] = useState("");
  //const [snapShotSrc, setSnapShotSrc] = useState<string[]>([]);
  const [showPopover, setShowPopover] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const itemRef = useRef(null);

  function handleClickAlert() {
    Object.assign(dataAlert, {
      alertTime: formatContextDate(new Date(Number(dataAlert.createdAt))),
      startTime: dataAlert.createdAt,
      status: thisAlertStatus || dataAlert.status,
      tag: { name: thisAlertTag, desc: thisTagDesc },
      reviewed: { reviewed: thisAlertTag || dataAlert?.reviewed?.reviewed },
    });
    setActiveAlert(dataAlert);
    if (dataAlert.video?.url) {
      setVideoUrl(dataAlert.video.url);
    } else {
      setVideoUrl("");
    }

    return;
  }

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!dataAlert) {
      return;
    }
    if (searchParams?.get("id") == alertId) {
      setSearchParams("");
      handleClickAlert();
    }

    getSnapShotByAlertObj(dataAlert)
      .then((data) => {
        itemRef.current && setSnapShotSrc(URL.createObjectURL(data));
      })
      .catch((e) => console.error(e));
  }, [dataAlert]);

  useEffect(() => {
    return () => {
      snapShotSrc && URL.revokeObjectURL(snapShotSrc);
    };
  }, [snapShotSrc]);
  //normal alert case
  useEffect(() => {
    if (
      !showPopover ||
      !dataAlert ||
      Array.isArray(dataAlert.searchResult?.boundingBoxList) ||
      dataAlert.matchedVehicle?.boundingBox
    ) {
      return;
    }
    getTargetImgByAlertObj(dataAlert)
      .then((data) => {
        data && itemRef.current && setTargetImgSrc(URL.createObjectURL(data));
      })
      .catch((e) => console.error(e));
  }, [showPopover, dataAlert]);
  //magic search v2 casr
  useEffect(() => {
    if (
      !showPopover ||
      !dataAlert ||
      !Array.isArray(dataAlert.searchResult?.boundingBoxList) ||
      !naturalSize
    ) {
      return;
    }

    createImageWithBox(dataAlert.searchResult?.boundingBoxList);
  }, [showPopover, naturalSize]);
  //lpr search case
  useEffect(() => {
    if (
      !showPopover ||
      !dataAlert ||
      !dataAlert.matchedVehicle?.boundingBox ||
      !naturalSize
    ) {
      return;
    }
    // use snapshot as popup image
    getSnapShotByAlertObj(dataAlert)
      .then((data) => {
        itemRef.current && setSnapShotWithBoxSrc(URL.createObjectURL(data));
      })
      .catch((e) => console.error(e));
  }, [showPopover, naturalSize]);
  function drawLprBox(matchedVehicle) {
    if (!matchedVehicle) return null;
    const { x1, y1, x2, y2 } = matchedVehicle.boundingBox;
    const licensePlate = matchedVehicle.licensePlate;
    const width = x2 - x1;
    const height = y2 - y1;
    const textHeight = 38 / 450;
    return (
      <>
        <div
          style={{
            position: "absolute",
            top: (y1 - textHeight) * 100 + "%",
            left: Math.min((x1 - 0.05) * 100, 82) + "%",
            fontSize: "24px",
            color: "white",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          {licensePlate}
          <CopyOutlined
            onClick={() => {
              copyToClipBoard(licensePlate);
            }}
            style={{ marginLeft: "8px", cursor: "pointer" }}
          />
        </div>
        <div
          style={{
            position: "absolute",
            width: width * 100 + "%",
            height: height * 100 + "%",
            top: y1 * 100 + "%",
            left: x1 * 100 + "%",
            border: "2px solid #3E83F6",
          }}
        ></div>
      </>
    );
  }
  useEffect(() => {
    return () => {
      targetImgSrc && URL.revokeObjectURL(targetImgSrc);
    };
  }, [targetImgSrc]);

  useEffect(() => {
    if (activeAlert?.id === alertId) {
      setThisAlertStatus(activeAlert?.status);
      setThisAlertTag(activeAlert?.tag?.name);
      setThisTagTagDesc(activeAlert?.tag?.desc);
      setThisReviewed(activeAlert?.reviewed?.reviewed);
      if (!isInView) {
        itemRef?.current?.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [activeAlert]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      {
        root: null, // Use the viewport as the container
        rootMargin: "0px",
        threshold: 0.1, // Trigger when 10% of the element is visible
      },
    );

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, []);

  const handleSnapshotLoad = async () => {
    if (imgRef.current) {
      const { naturalWidth, naturalHeight } = imgRef.current;
      setNaturalSize({ width: naturalWidth, height: naturalHeight });
    }
  };

  const createImageWithBox = async (cropAreas) => {
    const img = imgRef.current;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = naturalSize.width;
    canvas.height = naturalSize.height;

    try {
      // 绘制原始图片
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      cropAreas.forEach((area, i) => {
        // const { x, y, width, height } = area.rawBox;

        let { x1, y1, x2, y2 } = area.rawBox;
        const scalingRatio = naturalSize.width / area.rawBox.width;
        x1 = x1 * scalingRatio;
        y1 = y1 * scalingRatio;
        x2 = x2 * scalingRatio;
        y2 = y2 * scalingRatio;
        const safeCropArea = {
          x: Math.max(0, Math.min(x1, naturalSize.width)),
          y: Math.max(0, Math.min(y1, naturalSize.height)),
          width: Math.max(0, Math.min(x2 - x1, naturalSize.width - x1 - 2)),
          height: Math.max(0, Math.min(y2 - y1, naturalSize.height - y1 - 2)),
        };
        const color =
          REGION_INDEX_COLOR[i % Object.values(REGION_INDEX_COLOR).length];

        ctx.strokeStyle = color;
        ctx.lineWidth = 10;
        ctx.strokeRect(
          safeCropArea.x,
          safeCropArea.y,
          safeCropArea.width,
          safeCropArea.height,
        );
      });
    } catch (e) {
      console.warn("draw box error", e);
    }
    // 将 canvas 转换为图片 URL
    const dataUrl = canvas.toDataURL("image/png");
    setSnapShotWithBoxSrc(dataUrl);
  };

  const isActive = activeAlert?.id === alertId;
  const isGunAlert = dataAlert?.eventTypes?.includes("human_with_gun");

  const displaySvgIcons = () => {
    const attrs = dataAlert?.attrs;
    return (
      <div className="flex mx-2">
        {attrs?.vehicles?.length > 0 &&
          attrs?.vehicles[0].color !== "color_unknown" && (
            <SvgAlertVehicleColor
              width="16"
              fill={ALERT_VEHICLE_CAR_COLOR[attrs?.vehicles[0].color]}
            />
          )}
        {attrs?.persons?.length > 0 &&
          attrs?.persons[0].coatColor &&
          attrs?.persons[0].coatColor !== "color_unknown" && (
            <SvgAlertPeopleCoat
              width="16"
              fill={ALERT_VEHICLE_CAR_COLOR[attrs?.persons[0].coatColor]}
            />
          )}
        {attrs?.persons?.length > 0 &&
          attrs?.persons[0].trousersColor &&
          attrs?.persons[0].trousersColor !== "color_unknown" && (
            <SvgAlertPeopleTrousers
              width="16"
              fill={ALERT_VEHICLE_CAR_COLOR[attrs?.persons[0].trousersColor]}
            />
          )}
      </div>
    );
  };

  const popContent = () => {
    if (snapShotWithBoxSrc) {
      return (
        <div className="flex max-w-[800px] w-[800px] max-h-[600px] h-[600px] overflow-hidden gap-1 items-center">
          <TransformWrapper
            initialScale={1}
            initialPositionX={0}
            initialPositionY={0}
            centerOnInit={true}
            disablePadding={true}
            doubleClick={{ disabled: true }}
          >
            {() => (
              <React.Fragment>
                <TransformComponent
                  wrapperClass="!w-full !h-full "
                  contentClass="!w-full !h-full flex justify-center items-center"
                >
                  <div style={{ position: "relative" }}>
                    {drawLprBox(dataAlert?.matchedVehicle)}
                    <img
                      src={snapShotWithBoxSrc}
                      className="p-0.5 bg-white max-w-full max-h-full !rounded-lg object-contain"
                    />
                  </div>
                </TransformComponent>
              </React.Fragment>
            )}
          </TransformWrapper>
        </div>
      );
    } else if (targetImgSrc) {
      return (
        <div className="flex max-w-[300px] w-[300px] max-h-[300px] h-[300px] overflow-hidden gap-1 items-center">
          <img
            src={targetImgSrc}
            className="p-0.5 bg-white max-w-full max-h-full !rounded-lg object-contain"
          />
        </div>
      );
    } else {
      return (
        <div className="flex items-center justify-center w-64 h-48 border rounded-lg bg-white">
          <div
            className="ml-1 text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status"
          ></div>
        </div>
      );
    }
  };

  return (
    <>
      <Popover
        arrow={false}
        // trigger={"click"}
        placement="right"
        onOpenChange={setShowPopover}
        overlayInnerStyle={{
          padding: 0,
          borderRadius: "16px",
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
        content={popContent()}
      >
        <div
          ref={itemRef}
          onClick={() => handleClickAlert()}
          className={clsx(
            "focus:outline-none py-4 px-6 cursor-pointer",
            isActive
              ? "bg-blue-100 hover:bg-blue-100"
              : isGunAlert
                ? "bg-[#FFEDEB]"
                : "hover:bg-zinc-100",
          )}
        >
          <div className="w-full flex items-center gap-3 ">
            <div
              className={clsx(
                "relative rounded-lg h-[70px] flex-shrink-0 aspect-video flex items-center justify-center bg-zinc-100",
                { "border-2 border-[#F73D2F]": isGunAlert },
              )}
            >
              {snapShotSrc ? (
                <img
                  ref={imgRef}
                  src={snapShotSrc}
                  alt="Camera Snapshot"
                  className="aspect-video rounded-lg"
                  width="124"
                  height="90"
                  onLoad={handleSnapshotLoad}
                />
              ) : (
                <SvgLogo width="28" className="fill-zinc-400" />
              )}
            </div>
            <div className="flex flex-col justify-between flex-grow gap-1 max-w-[200px]">
              <div className="flex justify-between w-full">
                <div className="flex space-x-1">
                  <p
                    className={clsx(
                      "text-sm font-semibold leading-tight text-nowrap max-w-[126px] overflow-hidden break-words break-all text-ellipsis",
                      {
                        "text-[#F73D2F]": isGunAlert,
                      },
                    )}
                  >
                    {dataAlert.matchedVehicle?.licensePlate ||
                      getEventText(
                        dataAlert?.eventTypes?.at(0),
                        dataAlert?.attrs?.vehicles?.at(0)?.plate?.no,
                      )}
                  </p>
                  {displaySvgIcons()}
                  {dataAlert?.assetTracking && (
                    <Tooltip
                      title={
                        <div>
                          <p className="text-center">
                            Database: {dataAlert?.assetTracking?.name || "-"}
                          </p>
                          <p className="text-center">
                            Record: {dataAlert?.assetTracking?.recordName}
                            {"(" +
                              (dataAlert?.assetTracking?.threshold?.toFixed(
                                2,
                              ) || "-") +
                              ")"}
                          </p>
                          <p className="text-center">
                            <a
                              className="font-semibold text-center hover:text-zinc-100"
                              href={`/dashboard/database/${dataAlert?.assetTracking?.id}?tag=${dataAlert?.assetTracking?.recordName}`}
                              target="_blank"
                            >
                              View Details{">"}
                            </a>
                          </p>
                        </div>
                      }
                    >
                      <div className="fill-neutral-500 hover:fill-neutral-400">
                        <SvgToastInfo width="16" className="" />
                      </div>
                    </Tooltip>
                  )}
                </div>
                <div className="flex items-center gap-1">
                  {user?.role === USER_ROLE.Inspector &&
                    (dataAlert?.reviewed?.reviewed || thisReviewed) && (
                      <SvgAlertReviewed width="18" className="fill-[#3E83F6]" />
                    )}
                  <p
                    className="text-sm overflow-hidden break-words text-nowrap text-ellipsis px-2 rounded-md font-semibold"
                    style={getAlertStatusStyles(
                      thisAlertStatus ?? dataAlert?.status,
                    )}
                  >
                    {formatAlertStatusSDKToDisplay(
                      thisAlertStatus ?? dataAlert?.status ?? "",
                    )}
                  </p>
                </div>
              </div>
              <div className="flex justify-between w-full text-neutral-500 text-sm">
                <Tooltip title={dataAlert.site?.name}>
                  <p className="max-w-32 overflow-hidden break-words text-nowrap text-ellipsis break-all">
                    {dataAlert.site.name}
                  </p>
                </Tooltip>
                <p>{formatMinute(parseInt(dataAlert.createdAt))}</p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p className="max-w-full text-neutral-500 overflow-hidden break-all break-words text-nowrap text-ellipsis">
                  {dataAlert.camera.name}
                </p>
                {!dataAlert.isAlert && <SvgBlackShield width="18" />}

                {/* {gptText && <span>{dataAlert.searchRerankScore || ""}</span>} */}
              </div>
            </div>
          </div>
        </div>
      </Popover>
    </>
  );
}
